import goodsClassify from './goods-classify/index.vue';
import goodsSkuList from './goods-sku/index.vue';
import goodsCombinationList from './goods-combination/index.vue';

export default [
    {
        name: '商品列表',
        path: '/goods/goods-sku-list',
        component: goodsSkuList,
    },
    {
        name: '店内分类',
        path: '/goods/goods-classify',
        component: goodsClassify,
    },
    {
        name: '组合商品',
        path: '/goods/goods-combination',
        component: goodsCombinationList,
    },
];
